import React from 'react';
import {
    MobileWrap,
    Nav,
    NavBarCollapse,
    NavList,
    MobileSubmenuList,
    NavListItem,
} from './styled';
import { HeaderLink, HeaderHamburger, LanguageMenu } from '..';
import { LangBlock } from './styled/lang-block';
import { headerSubMenuItemsRu, headerSubMenuItemsEn } from 'consts';
import { Lang, MenuElement } from 'types';
import { langMapper } from 'utils/index';
import i18n from 'config/i18n';

export interface Props {
    links: MenuElement[];
    handleOnClick: () => void;
    closeMenu: () => void;
    isPressed: boolean;
    isMobileMenuOpened: boolean;
}

export const HeaderNav: React.FC<Props> = ({
    links,
    isPressed,
    handleOnClick,
    closeMenu,
    isMobileMenuOpened,
}) => {
    const menuItems =
        langMapper[i18n.language] === Lang.Ru
            ? headerSubMenuItemsRu
            : headerSubMenuItemsEn;

    return (
        <Nav data-at-selector={'pageHeader'}>
            <NavBarCollapse collapse={!isMobileMenuOpened}>
                <MobileWrap>
                    <NavList>
                        {links.map((item) => (
                            <NavListItem key={item.i18nKey}>
                                <HeaderLink {...item} onClick={closeMenu} />
                            </NavListItem>
                        ))}
                    </NavList>
                    <MobileSubmenuList>
                        {menuItems.map((item) => (
                            <NavListItem key={item.i18nKey}>
                                <HeaderLink {...item} />
                            </NavListItem>
                        ))}
                    </MobileSubmenuList>
                    <HeaderHamburger
                        handleOnClick={() => handleOnClick()}
                        isPressed={isPressed}
                        isMobile={false}
                    />
                    <LangBlock>
                        <NavListItem>
                            <LanguageMenu />
                        </NavListItem>
                    </LangBlock>
                </MobileWrap>
            </NavBarCollapse>
        </Nav>
    );
};

export default HeaderNav;
